import React, { useState, useEffect } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import VideoWebcamRecorder from './Recorder';
import './Celebrate.css';


/**
 * Plays the celebrate video module shown at the end of each day
 * @param {*} props
 * @returns the HTML code for the celebrate module
 */
export default function Celebrate(props) {
  // Initialize variables to be used later
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const dispatch = useDispatch();
  const [displayCelebrateAfterVideo, setDisplayCelebrateAfterVideo] = useState(false);
  const [displayCelebrateRecord, setDisplayCelebrateRecord] = useState(true);
  const [audioReady, setAudioReady] = useState(false);
  const [animalSize, setAnimalSize] = useState(props.bigAnimal  ? (props.lizard ? 'lizard' : 'bigAnimal') : 'animateAnimal15')
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const isIOS = () => {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  //how to get the most recent value of displayAudio
  useEffect(() => {
    if(displayCelebrateAfterVideo && isIOS()) {
      sleep(5000).then(() => {
        props.close();
      });
    }
  }, [displayCelebrateAfterVideo]);

  // The actual HTML code that determines whether to show the module above.
  return (
    <>
        {displayCelebrateRecord && (
            <VideoWebcamRecorder
                background={props.background}
                outputText={props.text}
                name={props.name}
                setDisplayCelebrateAfterVideo={setDisplayCelebrateAfterVideo}
                setDisplayCelebrateRecord={setDisplayCelebrateRecord}
                animal={props.animal}
                voice1={props.voice1}
                level1={props.level1}
                close={props.setDisplayCelebrate}
            />
        )}
        {displayCelebrateAfterVideo && (
            <audio
                autoPlay
                onPlay={() => {
                setAudioReady(true);
                }}
                onEnded={() => props.close()}
            >
                <source src={props.voice2}></source>
            </audio>
        )}
        {displayCelebrateAfterVideo && (
            <img
                alt='animation'
                className= {animalSize}
                style={audioReady ? {} : { display: 'none' }}
                src={props.animation}
            />
        )}
    </>

  )
}
